import actions from './actions.js'
import mutations from './mutations.js'

const state = {
  targets: [],
  displayOptions: {
    sortBy: 'created',
    sortDir: -1,
  },
  loading: false,
  openAPTargets: [],
  ignoredOpenAPTargets: [],
  activatedFailed: false,
  targetSearch: '',
  assignedOpenAP: [],
  showOpenAPImportModal: false,
  showOpenAPAssignModal: false,
  previousFilter: {},
  refreshTable: false,
  columnFilters: {},
}

const getters = {
  nonIgnoredTargets(state) {
    if (state.ignoredOpenAPTargets.length > 0) {
      let dict = {}
      for (let t of state.openAPTargets) {
        dict[t.segment_id] = t
      }
      for (let sID of state.ignoredOpenAPTargets) {
        if (dict[sID]) {
          delete dict[sID]
        }
      }
      return Object.values(dict)
    } else {
      return state.openAPTargets
    }
  },
  // TODO need to ensure that the targetDefinition is handeled in the current Target store, not here
  targetDefinition(state, getters) {
    return getters.currentTarget ? getters.currentTarget.target_definition : {}
  },
  targetAdvertisers(state) {
    const s = {}
    const targets = state.targets
    for (let i = 0; i < targets.length; i++) {
      const t = targets[i]
      if (t.advertiser) {
        if (t.advertiser.Advertiser_id) {
          s[t.advertiser.Advertiser_id] = t.advertiser
        }
      }
    }
    const values = Object.values(s)
    values.sort((a, b) => {
      var nameA = a.Name.toUpperCase()
      var nameB = b.Name.toUpperCase()

      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    })
    return values
  },
  refreshTable(state) {
    return state.refreshTable
  },
  columnFilters(state) {
    if (state.columnFilters && Object.keys(state.columnFilters).length > 0) {
      return state.columnFilters
    } else {
      return JSON.parse(localStorage.getItem('DASHBOARD_COLUMN_FILTER_VALUES'))
    }
  },
}

const module = {
  state,
  getters,
  mutations,
  actions,
}

export default module



// WEBPACK FOOTER //
// ./src/app/views/audienceHub/store/index.js